import { render } from "./WechatModal.vue?vue&type=template&id=49b5af24"
import script from "./WechatModal.vue?vue&type=script&lang=js"
export * from "./WechatModal.vue?vue&type=script&lang=js"

import "./WechatModal.vue?vue&type=style&index=0&id=49b5af24&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__